import { userHasLevel } from "../../../engine/AuthRoute";
import {
  languagesList,
  renderLangueInterprete,
  renderUserName,
  roles,
} from "../../../utils/constants";
import React from "react";
import { typeInterventionInputs } from "../PrestationDetail/PrestationDetailForm";
import { t } from "i18next";

export const inputsSelector = ({
  setDataForm,
  dataForm,
  user,
  formRef,
  interpreteRef,
}) => [
  {
    parentLabel: "",
    children: [
      {
        label: t("inputsSelector.institutionLabel"),
        disabled: !userHasLevel({
          not: {
            [roles.institution]: "", //
          },
        }),
        name: "institution",
        value: userHasLevel({
          not: {
            [roles.institution]: "", //
          },
        })
          ? null
          : user.institution,
        onChange: ({ value }) => {
          setDataForm({
            ...dataForm,
            institution: value,
          });
        },
        type: "dynamic-select",
        required: true,
        endPoint: "institutions",
        itemsCallBack: (institutions, form) => {},
        itemCallback: item => {
          return {
            key: item._id,
            label: `${item.name}`,
            value: item._id,
          };
        },
        col: 24,
      },
      {
        label: t("inputsSelector.interpreteLabel"),
        name: "interpretes",
        updateEndPoint: [dataForm.institution],
        required: true,
        hidden: dataForm.institution === undefined,
        type: "dynamic-select",
        endPoint: `users?role=${roles.interprete}&institutionsToAvoid=${dataForm.institution}`, //
        col: 24,
        onChange: (props, all) => {
          setDataForm({
            ...dataForm,
            interprete: props.value,
            languages: undefined,
            "intervention.type": undefined,
          });
          props.ref.current.setFieldsValue({
            languages: undefined,
            "intervention.type": undefined,
          });
        },
        noSorting: true,
        itemCallback: item => {
          return {
            key: item._id,
            label: (
              <span>
                <b>{renderUserName(item)}</b>
                <cite> {renderLangueInterprete(item)}</cite>
              </span>
            ),
            value: item._id,
            search: renderUserName(item) + " " + renderLangueInterprete(item),
          };
        },
      },
      {
        required: true,
        showSearch: true,
        hidden: dataForm.interprete === undefined,
        label: t("inputsSelector.languageLabel"),
        name: "languages",
        updateEndPoint: [dataForm.interprete],
        type: "dynamic-select",
        endPoint: `users/${dataForm.interprete}/languages`,
        col: 24,
        itemCallback: item => {
          return {
            key: item.value,
            label: `${languagesList().find(e => e.value === item.value).label}`,
            value: item.value,
          };
        },
      },
    ],
  },
  typeInterventionInputs({
    interpreteRef,
    hidden: dataForm.interprete === undefined,
  }),
];
